import React from "react";
import NavLink from "./NavLink";
import Navlist from "./NavigationList";

export default function MenuList() {
  return (
    // <div
    //   className="min-h-screen w-full cursor-pointer overflow-y-auto  scrollbar-track-transparent 
    //              scrollbar-thumb-gray-400 hover:scrollbar-thumb-gray-600 scrollbar-thumb-rounded-lg 
    //              mt-2
    //               border-y-2 
    //               "
    // >
    <div className='w-full pt-4'>
      {Navlist?.map((data, index) => (
        <NavLink data={data} key={index} />
      ))}
    </div>
  );
}
